export const GET_PUBLIC_TEMPLATES_REQUEST = 'GET_PUBLIC_TEMPLATES_REQUEST';
export const GET_PUBLIC_TEMPLATES_SUCCESS = 'GET_PUBLIC_TEMPLATES_SUCCESS';
export const GET_PUBLIC_TEMPLATES_ERROR = 'GET_PUBLIC_TEMPLATES_ERROR';

export const CREATE_PUBLIC_TEMPLATE_REQUEST = 'CREATE_PUBLIC_TEMPLATE_REQUEST';
export const CREATE_PUBLIC_TEMPLATE_SUCCESS = 'CREATE_PUBLIC_TEMPLATE_SUCCESS';
export const CREATE_PUBLIC_TEMPLATE_ERROR = 'CREATE_PUBLIC_TEMPLATE_ERROR';

export const DELETE_PUBLIC_TEMPLATE_REQUEST = 'DELETE_PUBLIC_TEMPLATE_REQUEST';
export const DELETE_PUBLIC_TEMPLATE_SUCCESS = 'DELETE_PUBLIC_TEMPLATE_SUCCESS';
export const DELETE_PUBLIC_TEMPLATE_ERROR = 'DELETE_PUBLIC_TEMPLATE_ERROR';

export const COPY_PUBLIC_TEMPLATE_REQUEST = 'COPY_PUBLIC_TEMPLATE_REQUEST';
export const COPY_PUBLIC_TEMPLATE_SUCCESS = 'COPY_PUBLIC_TEMPLATE_SUCCESS';
export const COPY_PUBLIC_TEMPLATE_ERROR = 'COPY_PUBLIC_TEMPLATE_ERROR';

export const CLEAR_PUBLIC_TEMPLATES_STATE = 'CLEAR_PUBLIC_TEMPLATES_STATE';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';
export const CLEAR_ERRORS_PROFILE = 'CLEAR_ERRORS_PROFILE';
export const INIT_REDUCER = 'INIT_REDUCER';

export const UPDATE_PUBLIC_TEMPLATE_REQUEST = 'UPDATE_PUBLIC_TEMPLATE_REQUEST';
export const UPDATE_PUBLIC_TEMPLATE_SUCCESS = 'UPDATE_PUBLIC_TEMPLATE_SUCCESS';
export const UPDATE_PUBLIC_TEMPLATE_ERROR = 'UPDATE_PUBLIC_TEMPLATE_ERROR';
export const CREATE_ERRORS = 'CREATE_ERRORS';
export const CLEAR_PUBLIC_TEMPLATE_COPIED = 'CLEAR_PUBLIC_TEMPLATE_COPIED';
